import { render, staticRenderFns } from "./ReturnToCartPopup.vue?vue&type=template&id=34d2cc6c&scoped=true&"
import script from "./ReturnToCartPopup.vue?vue&type=script&lang=js&"
export * from "./ReturnToCartPopup.vue?vue&type=script&lang=js&"
import style0 from "./ReturnToCartPopup.vue?vue&type=style&index=0&id=34d2cc6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d2cc6c",
  null
  
)

export default component.exports